import { useScroll } from "ahooks";
import { Select } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

import { useMemo, useRef } from "react";
import useViewModel from "./viewModel";

/**
 *
 * @param {Object} props 支持 Select 所有参数
 * @param {Array<{tag_name: string, count: number}=>} props.allTags 所有标签列表
 * @param {Array<string>=} props.tagsToSelect 可供下拉选择的标签列表
 * @param {boolean=} props.suggestVisible "推荐"是否可见, 默认true
 * @param {boolean=} props.useLabel 是否开启label效果，默认false， 使用placeholder作为label
 * @param {string=} props.placeholder
 * @param {string=} props.labelBackground label的背景色，默认white
 * @param {string[]=} props.tags 标签列表
 * @param {string[]=} props.value 标签列表
 * @param {(value: string[])=>void =} props.onChange
 * @param {boolean=} props.open
 * @param {boolean=} props.isNew 标签列表标签的label
 * @param {string=} props.className 组件样式
 * @param {string[] | boolean=} props.suggestTags
 * @param {disabled=} props.disabled
 * @param {import("react").ReactChild=} props.children}
 * @returns {JSX.Element}
 */
export default function HBTagInput(props) {
  const {
    className,
    placeholder,
    allowClear,
    useLabel,
    labelBackground,
    disabled,
    placement = "bottomLeft",
    searchValue,
    onSuggestTagClick,
    onSelectChange,
    onSearchChange,
    suggestTags,
    suggestVisible,
    tags,
    open,
    children,
    tagLabel,
    dropdownAlign,
    options,
    getPopupContainer,
    onInputKeyDown,
    onFocus,
    onBlur,
    filterOption,
  } = useViewModel(props);
  const tagInputRef = useRef(null);
  const scroll = useScroll(tagInputRef);
  const isNew = props.isNew || false;

  const offset = useMemo(() => {
    // 只有当placement 为top且容器内滚动了，则需要设置偏移量
    if (placement?.includes("top")) {
      return [0, -scroll?.top];
    }
    return [0, 0];
  }, [scroll, placement]);

  return (
    <div
      className={classNames(
        styles.tagInput,
        className,
        {
          [styles.useLabel]: useLabel && placeholder,
          [styles.hasValue]: tags?.length,
          [styles.disabled]: disabled,
        },
        isNew && styles.isNew
      )}
      ref={tagInputRef}
      onClick={onFocus}
    >
      <Select
        mode={"tags"}
        className={classNames(styles.editArea, props.selectClassName)}
        bordered={false}
        placeholder={useLabel ? undefined : placeholder}
        onChange={onSelectChange}
        value={tags}
        allowClear={allowClear}
        placement={placement}
        disabled={disabled}
        searchValue={searchValue}
        onSearch={onSearchChange}
        open={open}
        onInputKeyDown={onInputKeyDown}
        dropdownAlign={
          dropdownAlign || {
            targetOffset: offset,
          }
        }
        dropdownClassName={styles.dropdown}
        notFoundContent={null}
        options={options}
        listHeight={260}
        onFocus={onFocus}
        onBlur={onBlur}
        filterOption={filterOption}
        getPopupContainer={getPopupContainer || (() => document.body)}
      ></Select>

      {useLabel && placeholder && (
        <div
          className={styles.placeholderLabel}
          style={{ background: labelBackground }}
        >
          {placeholder}
        </div>
      )}
      <div className={styles.bottomContainer}>
        {children}

        {suggestVisible && !!suggestTags?.length && (
          <div
            className={classNames(styles.suggests, isNew && styles.isNew)}
            data-gd-click="resource_loc_click"
            data-gd-expose="resource_loc_expose"
            data-resource-type="文字"
            data-resource-id="0"
            data-resource-title="推荐标签"
            data-content-source="采集弹窗"
          >
            {!isNew && (tagLabel || "常用") + "："}
            {suggestTags.map((tag) => (
              <span key={tag} onClick={onSuggestTagClick} data-tag={tag}>
                {isNew && <span className={styles.tagIcon}>#</span>}
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
